import { AccountUsageType, Environment, ApplicationCategory, Brand } from './types';

// Email domains and addresses described in requirements
export const EMAIL_DOMAINS = {
  DEVOPS_ASIA: 'devops-asia@appfire.com',
  DEVOPS_EU: 'devops-eu@appfire.com',
  ITOPS: 'itops_alerts@appfire.com',
  PLATFORM: 'prakhar.srivastav@appfire.com',
} as const;

export const ACCOUNT_USAGE_OPTIONS = [
  { label: AccountUsageType.PlatformSharedServices, value: AccountUsageType.PlatformSharedServices },
  { label: AccountUsageType.PlatformInfrastructure, value: AccountUsageType.PlatformInfrastructure },
  { label: AccountUsageType.DevOps, value: AccountUsageType.DevOps },
  { label: AccountUsageType.ITOps, value: AccountUsageType.ITOps },
  { label: AccountUsageType.FuseApp, value: AccountUsageType.FuseApp },
  { label: AccountUsageType.NonFuseApp, value: AccountUsageType.NonFuseApp },
  { label: AccountUsageType.Developer, value: AccountUsageType.Developer },
];

export const APPLICATION_CATEGORIES = [
  { label: ApplicationCategory.Agile, value: ApplicationCategory.Agile },
  { label: ApplicationCategory.BIReporting, value: ApplicationCategory.BIReporting },
  { label: ApplicationCategory.DeveloperTools, value: ApplicationCategory.DeveloperTools },
  { label: ApplicationCategory.DocumentManagement, value: ApplicationCategory.DocumentManagement },
  { label: ApplicationCategory.ITSM, value: ApplicationCategory.ITSM },
  { label: ApplicationCategory.PPM, value: ApplicationCategory.PPM },
  { label: ApplicationCategory.Publishing, value: ApplicationCategory.Publishing },
  { label: ApplicationCategory.TimeTracking, value: ApplicationCategory.TimeTracking },
  { label: ApplicationCategory.VisualCollaboration, value: ApplicationCategory.VisualCollaboration },
  { label: ApplicationCategory.ServiceRocket, value: ApplicationCategory.ServiceRocket },
];

export const APPLICATION_TYPE_ACCOUNT_USAGES = [
  AccountUsageType.PlatformSharedServices,
  AccountUsageType.PlatformInfrastructure,
  AccountUsageType.FuseApp,
  AccountUsageType.NonFuseApp,
];

export const ENVIRONMENT_OPTIONS = [
  { label: 'Sandbox', value: Environment.Sandbox },
  { label: 'DTS', value: Environment.DTS },
  { label: 'Production', value: Environment.Prod },
];

export const DEVELOPER_ENVIRONMENT_OPTIONS = [
  { label: 'Sandbox', value: Environment.Sandbox },
];

// Email domains for DevOps and Non-Fuse App accounts
export const DEVOPS_EMAIL_OPTIONS = [
  { label: EMAIL_DOMAINS.DEVOPS_ASIA, value: EMAIL_DOMAINS.DEVOPS_ASIA },
  { label: EMAIL_DOMAINS.DEVOPS_EU, value: EMAIL_DOMAINS.DEVOPS_EU },
];

// TO DO: Add more brand options when we have access to https://appfireteam.atlassian.net/jira/assets
export const BRAND_OPTIONS = [
  { label: Brand.Appfire, value: Brand.Appfire },
];

export const DEFAULT_FIELDS = {
  environment: [Environment.Sandbox],
  admin_email: '',
};

export const ACCOUNT_USAGE_DEFAULT_FIELDS = {
  [AccountUsageType.PlatformSharedServices]: {
    ...DEFAULT_FIELDS,
    application_category: ApplicationCategory.Agile,
  },
  [AccountUsageType.PlatformInfrastructure]: {
    ...DEFAULT_FIELDS,
    admin_email: EMAIL_DOMAINS.PLATFORM,
    application_category: ApplicationCategory.Agile,
  },
  [AccountUsageType.DevOps]: {
    ...DEFAULT_FIELDS,
    admin_email: EMAIL_DOMAINS.DEVOPS_ASIA,
  },
  [AccountUsageType.ITOps]: {
    ...DEFAULT_FIELDS,
    admin_email: EMAIL_DOMAINS.ITOPS,
  },
  [AccountUsageType.FuseApp]: {
    ...DEFAULT_FIELDS,
    application_category: ApplicationCategory.Agile,
  },
  [AccountUsageType.NonFuseApp]: {
    ...DEFAULT_FIELDS,
    admin_email: EMAIL_DOMAINS.DEVOPS_ASIA,
    application_category: ApplicationCategory.Agile,
  },
  [AccountUsageType.Developer]: DEFAULT_FIELDS,
};